// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__enk3F","inline":"LoadingSpinner_inline__RGk51","spin":"LoadingSpinner_spin__Tac2j"};